import { FieldArray, FieldArrayRenderProps, FormikProps } from 'formik';
import React from 'react';
import { AddressField } from '../../../../global/components/form-element/address';
import { FormField } from '../../../../global/components/form-element/form-field';
import { DividerSection } from '../../../../global/components/layout/divider-section';
import { FormGroup } from '../../../../global/components/layout/form-group';
import { ContentSpacer } from '../../../../global/components/layout/generic-content-spacer';
import { YesNoIndicators } from '../../../../global/models/api-model';
import { LabelSettingProps } from '../../../../global/models/epi-model';
import { BasicInfo } from '../../../account-info/features/personal-info/basic-info';
import { EmailInfo } from '../../../account-info/features/personal-info/email-info';
import { PhoneInfo } from '../../../account-info/features/personal-info/phone-info';
import { MailingAddressFieldNames } from '../../../account-info/models/form-models';
import { getAddressLabels } from '../../../account-info/selectors/form-selectors';
import { InstitutionProps } from '../../models/arc-epi-props';
import { MinimalPersonInfoFields } from './officer-add-minimal-info-fields';
import { GetOfficerAddNonEpiscopalMailingAddressRequiredSchema, getPersonTypeOptions, OfficerAddFormValues, WithAccessTo } from './officer-add-form-model';

interface Props {
	labelSetting: LabelSettingProps;
	institutionProps: InstitutionProps;
	formProps: FormikProps<OfficerAddFormValues>;
  shouldShowMinimalForm: boolean;
}

export function OfficerAddFormFields(props: Props) {
	const { labelSetting, formProps, institutionProps, shouldShowMinimalForm } = props;

	const onWithAccessChange = (e, fieldArrayProps: FieldArrayRenderProps) => {
		const values = formProps.values.withAccessTo;
		const { value } = e.target;
		if (e.target.checked) {
			fieldArrayProps.push(value);
		} else {
			fieldArrayProps.remove(values.indexOf(value));
		}
	};

	return (
		<>
			<DividerSection sectionText={institutionProps?.officerInformationSectionTitle}>
				<FormGroup>
					<ContentSpacer>
						<FormField
							name='nonEpiscopal'
							label={institutionProps?.personTypeLabel}
							component='radioGroup'
							options={getPersonTypeOptions(institutionProps?.episcopalInstitutionEmployeeOptionText,
								institutionProps?.episcopalInstitutionEmployeeSupplementText,
								institutionProps?.nonEpiscopalInstitutionEmployeeOptionText,
								institutionProps?.nonEpiscopalInstitutionEmployeeSupplementText)}
							errors={props.formProps.errors}
							touched={props.formProps.touched}
							select
							required
						/>
					</ContentSpacer>
					<ContentSpacer>
						<FieldArray
							name='withAccessTo'
							render={(fieldArrayProps) => (

								<ContentSpacer>
									<div data-formdata='withAccessTo'>
										<h6>{institutionProps.withAccessLabel}</h6>

										<FormField
											id={WithAccessTo.map}
											key={WithAccessTo.map}
											name='withAccessTo'
											label={
												<>
													<p>{institutionProps.mapOptionText}</p>
													<p>{institutionProps.mapOptionHelperText}</p>
												</>
											}
											component='checkBox'
											touched={formProps.touched}
											errors={formProps.errors}
											value={WithAccessTo.map}
											checked={formProps.values.withAccessTo?.includes(WithAccessTo.map)}
											checkBoxGroup
											onChange={(e) => onWithAccessChange(e, fieldArrayProps)}

										/>
										<FormField
											id={WithAccessTo.cic}
											key={WithAccessTo.cic}
											name='withAccessTo'
											label={
												<>
													<p>{institutionProps.cicOptionText}</p>
													<p>{institutionProps.cicOptionHelperText}</p>
												</>
											}
											component='checkBox'
											touched={formProps.touched}
											errors={formProps.errors}
											value={WithAccessTo.cic}
											checked={formProps.values.withAccessTo?.includes(WithAccessTo.cic)}
											checkBoxGroup
											onChange={(e) => onWithAccessChange(e, fieldArrayProps)}

										/>
										<FormField
											id={WithAccessTo.bill_payer}
											key={WithAccessTo.bill_payer}
											name='withAccessTo'
											label={
												<>
													<p>{institutionProps.billPayerOptionText}</p>
													<p>{institutionProps.billPayerOptionHelperText}</p>
												</>
											}
											component='checkBox'
											touched={formProps.touched}
											errors={formProps.errors}
											value={WithAccessTo.bill_payer}
											checked={formProps.values.withAccessTo?.includes(WithAccessTo.bill_payer)}
											checkBoxGroup
											onChange={(e) => onWithAccessChange(e, fieldArrayProps)}

										/>
									</div>
								</ContentSpacer>

							)}
						/>

					</ContentSpacer>
				</FormGroup>
			</DividerSection>


			<DividerSection removeDivider sectionText={institutionProps?.personalInformationSectionTitle}>
				{
					shouldShowMinimalForm ?
						<MinimalPersonInfoFields
							labelSetting={labelSetting}
							formikProps={formProps}
						/>
						:
						<BasicInfo
							labelSetting={labelSetting}
							formikProps={formProps}
						/>
				}
			</ DividerSection>
			{
				!shouldShowMinimalForm &&
				<>
					<DividerSection>
						<ContentSpacer>
							<h3>{labelSetting.mailingAddressTitle}</h3>
						</ContentSpacer>
						<AddressField
							currentCountry={formProps.values.mailing_country === '' ? 'US' : formProps.values.mailing_country}
							labels={getAddressLabels(labelSetting)}
							addressFieldNames={MailingAddressFieldNames}
							requiredSchema={GetOfficerAddNonEpiscopalMailingAddressRequiredSchema()}
							formProps={formProps}
							person
							officerSearch={formProps.values.nonEpiscopal === YesNoIndicators.Yes}
						/>
					</ DividerSection>
					<PhoneInfo
						labelSetting={labelSetting}
						formProps={formProps}
					/>
				</>
			}
			<EmailInfo
				labelSetting={labelSetting}
				formProps={formProps}
				removeDivider
				officeEmailRequired
				officerSearch={formProps.values.nonEpiscopal === YesNoIndicators.Yes}
				personalEmailRequired
			/>
		</>
	);
}
